import { format } from "date-fns";
import api from "../services/api";

interface IOpenedResponse {
    codeResult: string;
    data: any[];
}

export interface IOpenedParams {
    year: string;
    month: string;

}
export interface IOpened {
    representante: string;
    revendedor: string;
    numero: number;
    acerto: string;
    status: number;
}


class OpenedRepository {
    public async Opened({ year, month }: IOpenedParams): Promise<IOpened[]> {        
        const endDate = format(new Date(parseInt(year), parseInt(month) - 1, 16, 0, 0, 0), "yyyy-MM-dd HH:mm:ss");

        const body = {
            "tables": ["Kit", "Pedido", "GerenteRegional", "GerenteSetor", "Representante", "Revendedor"],
            "sql": [
                {
                    "coderesult": "EmAberto",
                    "query": `SELECT Representante.nome as Representante, 
                    Revendedor.nome as Revendedor, 
                    Kit.numero as Numero, 
                    Pedido.acerto as Acerto, 
                    Kit.statusKit as Status 
                    FROM Kit 
                    INNER JOIN Pedido 
                    ON Pedido.id = Kit.pedidoId                     
                    LEFT JOIN Representante 
                    ON Representante.id = Pedido.representanteId 
                    LEFT JOIN Revendedor 
                    ON Revendedor.id = Kit.revendedorId 
                    WHERE Kit.statusKit <= 4 
                    AND Pedido.acerto <= '${endDate}' 
                    ORDER BY Representante.nome`
                }
            ]
        };

        const response = await api.post<IOpenedResponse[]>("reports", body);
        console.log(response);
        return this.GetFromCodeResult(response.data, "EmAberto").map(result => {
            return {
                representante: result.Representante,
                revendedor: result.Revendedor,
                numero: result.Numero,
                acerto: result.Acerto,
                status: result.Status
            }
        });
    }

    GetFromCodeResult(data: IOpenedResponse[], codeResult: string) {

        return data.find(result => result.codeResult === codeResult)?.data || [];
    }
}

const openedRepository = new OpenedRepository();
export default openedRepository;